<template>
  <v-app>
    <v-layout>
      <v-flex>
        <v-navigation-drawer
          v-model="drawer"
          app
          right
          min-height="0"
          floating
          temporary
        >
          <v-list dense>
              <v-list-item v-if="current_user">ログイン中</v-list-item>
              <router-link to="/">
                <v-list-item class="no-line">
                    <v-list-item-action>
                            <v-icon>home</v-icon>      
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Home</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
              </router-link>
              <v-divider></v-divider>
              <router-link to="/silver-exam1">
                <v-list-item class="no-line" v-if="current_user">
                    <v-list-item-action>
                            <v-icon>import_contacts</v-icon>      
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Silver問題１</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
              </router-link>
              <router-link to="/gold-exam1">
                <v-list-item class="no-line" v-if="current_user">
                    <v-list-item-action>
                            <v-icon>import_contacts</v-icon>      
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>Gold問題１</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
              </router-link>
              <a @click="signOut" v-if="current_user">
                <v-list-item >  
                <v-list-item-action>
                    <v-icon>exit_to_app</v-icon>
                </v-list-item-action>
            <v-list-item-content >
                    <v-list-item-title v-show="current_user">ログアウト</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
              </a>
              <a @click="signInGoogle" v-if="!current_user">
                <v-list-item >  
                <v-list-item-action>
                    <v-icon>mdi-google</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title >Googleでログイン</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
              </a>
              <a @click="signInGitHub" v-if="!current_user">
                <v-list-item >  
                <v-list-item-action>
                    <v-icon>mdi-github-box</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title >GitHubでログイン</v-list-item-title>
                </v-list-item-content>
                </v-list-item>
              </a>
              <v-list-item class="no-line">
                    <v-list-item-content>
                        <v-list-item-title>&copy; 2019 imanau</v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
          </v-list>
        </v-navigation-drawer>
      </v-flex>
    </v-layout>
    <v-app-bar
      app
      color="#EF5350"
      dark
      max-height="50px"
      fixed
      dense
    >
      <v-spacer></v-spacer>
      <v-toolbar-title>Ruby<v-icon>code</v-icon>技術者認定試験一問一答</v-toolbar-title>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
    </v-app-bar>
  </v-app>
</template>

<script>
import firebase from 'firebase'


  export default {
    props: {
      source: String,
    },
    data: () => ({
      drawer: null,
      current_user:""
    }),
    methods:{
      signOut: function () {
        firebase.auth().signOut().then(()=>{
          alert("ログアウトしました");
          this.$router.push('/signin')
          window.location.reload();
        })
      },
      signInGoogle:function(){
        const provider = new firebase.auth.GoogleAuthProvider()
        firebase.auth().signInWithPopup(provider).then(result => {
            alert('Google認証に成功しました');
            this.$router.push('/');
        }).catch(error => {
            this.errorMessage = error.message
            this.showError = true
        })
      },
      signInGitHub:function(){
        const provider = new firebase.auth.GithubAuthProvider();
        firebase.auth().signInWithPopup(provider).then(result => {
            alert('GitHub認証に成功しました');
            this.$router.push('/');
        }).catch(error => {
            this.errorMessage = error.message
            this.showError = true
        })
      }
    },
    created(){
        var self = this
        firebase.auth().onAuthStateChanged(function(user) {
        if (user) {
            self.current_user = user
        } 
        });
    }
  }
</script>

<style>
.v-application a {
    color: #1976d2;
    text-decoration: none;
}

</style>

